import styled, { css } from 'styled-components/macro'
import { transparentize } from 'polished'

export const Item = styled.h2`
  margin: 0;
  padding: 1rem;
  display: grid;
  grid-template-columns: auto;
  grid-template-areas:
    'Info'
    'Info';
  justify-content: flex-start;
  align-items: center;
  gap: 0 1rem;
  font-weight: ${(props) => props.theme.font.weight.medium};
  font-size: 1.6rem;
  line-height: 1.2;
  border-bottom: 0.1rem solid ${(props) => props.theme.color.elementBorder};
  ${(props) => props.theme.breakpoints.greaterThan('md')`
    height: 9.2rem;
    grid-template-columns: 4.8rem auto;
    grid-template-areas:
      'Icon Info'
      'Icon Info';
  `};
  ${(props) => props.theme.breakpoints.greaterThan('lg')`
    padding: 1.6rem;
  `};
`

export const Wrap = styled.section<{ layout?: string }>`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto;
  gap: 0;
  ${({ layout }) =>
    layout === 'approval' &&
    css`
      ${(props) => props.theme.breakpoints.greaterThan('sm')`
        grid-template-columns: repeat(2, 1fr);
        ${Item} {
          border-right: 0.1rem solid ${props.theme.color.elementBorder};
          border-bottom: 0.1rem solid ${props.theme.color.elementBorder};
        }
        ${Item}:nth-child(even) {
          border-right: none;
          border-bottom: 0.1rem solid ${props.theme.color.elementBorder};
        }
      `};
    `}
  ${({ layout }) =>
    layout === 'strategy' &&
    css`
      ${(props) => props.theme.breakpoints.greaterThan('sm')`
        grid-template-columns: repeat(2, 1fr);
        ${Item} {
          border-right: 0.1rem solid ${props.theme.color.elementBorder};
          border-bottom: 0.1rem solid ${props.theme.color.elementBorder};
        }
        ${Item}:nth-child(even) {
          border-right: none;
          border-bottom: 0.1rem solid ${props.theme.color.elementBorder};
        }
      `};
    `}
  ${({ layout }) =>
    layout === 'distribution' &&
    css`
      ${(props) => props.theme.breakpoints.greaterThan('sm')`
        grid-template-columns: repeat(2, 1fr);
        ${Item} {
          border-right: 0.1rem solid ${props.theme.color.elementBorder};
          border-bottom: 0.1rem solid ${props.theme.color.elementBorder};
        }
        ${Item}:nth-child(even) {
          border-right: none;
          border-bottom: 0.1rem solid ${props.theme.color.elementBorder};
        }
      `};
      ${(props) => props.theme.breakpoints.greaterThan('xl')`
        grid-template-columns: repeat(3, 1fr);
        ${Item}:nth-child(even) {
          border-right: 0.1rem solid ${props.theme.color.elementBorder};
          border-bottom: 0.1rem solid ${props.theme.color.elementBorder};
        }
        ${Item}:nth-child(3n+3) {
          border-right: none;
          border-bottom: 0.1rem solid ${props.theme.color.elementBorder};
        }
      `};
    `}
`

export const ItemInfo = styled.div`
  grid-area: Info;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.8rem;
`

export const ItemIcon = styled.div`
  grid-area: Icon;
  padding: 1rem;
  width: 4.8rem;
  height: 4.8rem;
  display: none;
  justify-content: center;
  align-items: center;
  color: ${(props) => props.theme.color.default};
  background-color: ${(props) => transparentize(0.8, props.theme.color.default)};
  border: 0.1rem solid ${(props) => props.theme.color.default};
  border-radius: 50%;
  ${(props) => props.theme.breakpoints.greaterThan('md')`
    display: flex;
  `};
`

export const ItemTitle = styled.span`
  display: flex;
  flex: 0 0 100%;
  font-size: 1.4rem;
  color: ${(props) => props.theme.color.textHintSecond};
  ${(props) => props.theme.breakpoints.greaterThan('sm')`
    font-size: clamp(1.4rem, 1.2vw, 1.8rem);
  `};
`

export const ItemValue = styled.span`
  color: ${(props) => props.theme.color.text};
`

export const Divider = styled.span`
  display: none;
  color: ${(props) => props.theme.color.text};
  ${(props) => props.theme.breakpoints.greaterThan('md')`
    display: inline-block;
  `};
`
